import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { settingsTypes } from '@/configuration/constants'

import { getSettingTypes } from '../helpers'
import * as Styles from './styles'

const SettingsMessage = ({ type, title, message }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const textColor = type === settingsTypes.global ? theme.colors.success.hover : theme.colors.info.hover

  return (
    <Styles.Wrapper>
      <Styles.Container>
        {getSettingTypes(theme)?.[type]?.icon}
        <Text type="titleS" color={textColor}>
          {title || t(getSettingTypes(theme)?.[type]?.title)}
        </Text>
      </Styles.Container>
      <Text type="bodyMRegular" color={textColor}>
        {message || t(getSettingTypes(theme)?.[type]?.description)}
      </Text>
    </Styles.Wrapper>
  )
}

export default SettingsMessage
